import { useContext, useState } from "react";
import {
  AmountItem,
  AmountList,
  AmountTitle,
  BlockAmount,
  BlockStakingAmount,
  BlockSummary,
  BlockTitle,
  ButtonListDuration,
  ContentDuration,
  ContentInnerLeft,
  ContentInnerRight,
  ContentRightInner,
  DurationHint,
} from "./styled";
import Duration from "../Duration";
import {
  ClickMaxAmount,
  SwapContent,
  SwapInput,
  SwapInputTitle,
  SwapInputValue,
  SwapInputWrapper,
} from "../../Swap/styled";
import { useMediaQuery } from "react-responsive";
import { useTonAddress, useTonWallet } from "@tonconnect/ui-react";
import { Controller, useForm } from "react-hook-form";
import wallet_icon from "../../../assets/Staking/icn_wallet.svg";
import TitleCommon from "../../../components/Common/Title";
import lightning from "../../../assets/Dashboard/Stake/lightning.png";
import lightning_light from "../../../assets/Dashboard/Stake/lightning_light.png";
import { ButtonCommon, ContextProviderWrapper, InputCommon } from "@kibble-exchange/uikit";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useGetBalancesQuery } from "store/api/dexApiSlice";
import { fromNano } from "@ton/core";
import { Flex } from "antd";
import { shorten } from "page/Presale/NewStake";

const Stake = () => {
  // const [switchActive, setSwichActive] = useState(false);
  // const [showMore, setShowMore] = useState(true);
  const {theme} = useContext(ContextProviderWrapper)!
      
  const [buyAmount, setBuyAmount] = useState("0");
  const isMobile = useMediaQuery({ maxWidth: 500 });
  const walletAddress = useTonAddress();
  const wallet = useTonWallet();
  const { data: balances, isLoading: loadingBalances } = useGetBalancesQuery(
    walletAddress,
    {
      skip: !wallet,
    }
  );
  const { control } = useForm({ mode: "onChange" });
  const { allPools, poolsWallet, globalPoolData, userPoolData }: any = useSelector((state: any) => state.pool);
  let location = useLocation();
  const poolAddress = location.pathname.substring(15, 65)
  const poolData = globalPoolData.filter((data: any) => data.address === poolAddress)
  let tokenBalance = 0;
  if(!loadingBalances && balances && poolData[0]) {
    tokenBalance = balances[poolData[0].quote.address] ?? 0
  }

  const getPendingReward = () => {
    if(!poolData || !poolData[0]) return 0;
    const id = poolData[0].id;
    if(!userPoolData || !userPoolData[id] || !globalPoolData) return 0;
    const currentTime = (Date.now() / 1000).toFixed(0)
    const jettonReward = globalPoolData[id].reward_per_second * (Number(currentTime) - globalPoolData[id].lastRewardTime);
    if(jettonReward < 0) return 0;
    const accTokenPerShare = (Number(globalPoolData[id].accTokenPerShare) + ((jettonReward * 1000000000) / globalPoolData[id].total_staked)).toFixed(0);
    const pendingReward = userPoolData[id].staked_amount * Number(fromNano(accTokenPerShare)) - userPoolData[id].reward_debt;
    
    return Number(fromNano(pendingReward.toFixed(0))).toFixed(2) + " " + globalPoolData[id].reward.symbol
  }
  const getUserStakeAmount = () => {
    if(!poolData || !poolData[0] || !userPoolData) return 0;
    const id = poolData[0].id;
    return fromNano(userPoolData[id].staked_amount)
  }

  const getClaimAmount = () => {
    return 0;
  }

  const getTotalStaked = () => {    
    if(!poolData || !poolData[0]) return 0;
    return fromNano(poolData[0].total_staked) + " " + poolData[0].quote.symbol
  }

  const getDepositFee = () => {
    if(!poolData || !poolData[0]) return 0;
    return poolData[0].deposit_fee + "%"
  }

  const getClaimFee = () => {
    if(!poolData || !poolData[0]) return 0;
    return poolData[0].claim_fee + "%"
  }

  const getPoolAddress = () => {
    if(!poolData || !poolData[0]) return 0;
    return shorten(poolAddress)
  }
  const countDecimals = (value: any) => {
    const valueAsString = String(value);
    const splitValue = valueAsString.split(".");
    return splitValue.length > 1 ? splitValue[1].length : 0;
  };
  const handleBuyAmount = (e: any) => {
    let value = e.target.value;

    // Replace commas with periods
    value = value.replace(/,/g, ".");

    // If the input is empty, set the value to an empty string
    if (value === "") {
      setBuyAmount(value);
      return;
    }

    // Ensure the value is either a number or a decimal point
    const isValidNumber = /^[0-9]*\.?[0-9]*$/;

    if (isValidNumber.test(value)) {
      const decimalsCount = countDecimals(value);

      if (decimalsCount <= 9) {
        setBuyAmount(value);
      }
    }
  };

  // const handleSwitch = () => {
  //   setSwichActive(!switchActive);
  // };
  // const handleShowMore = () => {
  //   setShowMore(!showMore);
  // };
  return (
    <>
      <ContentRightInner>
        <ContentDuration>
          <ContentInnerLeft>
            <BlockStakingAmount>
              <SwapContent>
                <SwapInput>
                  <SwapInputTitle>
                    <p>Amount</p>
                    <ClickMaxAmount>
                      {!isMobile && "Available: "} {fromNano(tokenBalance)} | <span>MAX</span>
                    </ClickMaxAmount>
                  </SwapInputTitle>
                  <SwapInputWrapper
                    style={{
                      cursor: walletAddress ? "pointer" : "not-allowed",
                    }}
                    active={1 > 0}
                  >
                    <Controller
                      name="fromAmount"
                      control={control}
                      render={({ field }: any) => (
                        <SwapInputValue>
                          <InputCommon
                            {...field}
                            disabled={walletAddress ? false : true}
                            onChange={handleBuyAmount}
                            // onFocus={handleResetValueFrom}
                            placeHolder={"0"}
                            value={buyAmount}
                          />
                        </SwapInputValue>
                      )}
                    />
                    {/* ---------- */}
                  </SwapInputWrapper>
                </SwapInput>
              </SwapContent>
            </BlockStakingAmount>
            <AmountList>
                {DataDurationList.map((item: any, index: number) => {
                  return (
                    (
                      <>
                        <AmountItem key={index}>
                          <span>{item.pendingReward.title}</span>
                          <span>{getPendingReward()}</span>
                        </AmountItem>
                        <AmountItem key={index}>
                          <span>{item.yourStakedAmount.title}</span>
                          <span>{getUserStakeAmount()}</span>
                        </AmountItem>
                        <AmountItem key={index}>
                          <span>{item.yourClaimableAmount.title}</span>
                          <span>{getClaimAmount()}</span>
                        </AmountItem>
                      </>
                    )
                  );
                })}
              </AmountList>
            {/* <DurationHint className={theme}>
              <figure>
                <img src={theme === "light" ? lightning_light : lightning} alt="lightning" />
              </figure>
              <p>
                You cannot unstake before the time you selected when staking.
              </p>
            </DurationHint> */}
            <Flex>
              <ButtonCommon >
                <p>Stake</p>
                <img
                  width={17}
                  height={17}
                  style={{
                    marginLeft: "8px",
                  }}
                  src={wallet_icon}
                  alt="wallet"
                />
              </ButtonCommon>
              <ButtonCommon >
                <p>Unstake</p>
                <img
                  width={17}
                  height={17}
                  style={{
                    marginLeft: "8px",
                  }}
                  src={wallet_icon}
                  alt="wallet"
                />
              </ButtonCommon>
            </Flex>
          </ContentInnerLeft>
          <ContentInnerRight>
            <BlockAmount>
              <TitleCommon text="Pool details" />
              <AmountList>
                {DataDurationList.map((item: any, index: number) => {
                  return (
                    (
                      <>
                        <AmountItem key={index}>
                          <span>{item.staked.title}</span>
                          <span>{getTotalStaked()} </span>
                        </AmountItem>
                        <AmountItem key={index}>
                          <span>{item.depositFee.title}</span>
                          <span>{getDepositFee()}</span>
                        </AmountItem>
                        <AmountItem key={index}>
                          <span>{item.claimFee.title}</span>
                          <span>{getClaimFee()}</span>
                        </AmountItem>
                        <AmountItem key={index}>
                          <span>{item.exchange.title}</span>
                          <span>{item.exchange.value}</span>
                        </AmountItem>
                        <AmountItem key={index}>
                          <span>{item.poolAddress.title}</span>
                          <span>{getPoolAddress()}</span>
                        </AmountItem>
                      </>
                    )
                  );
                })}
              </AmountList>
            </BlockAmount>
            <BlockSummary>
              <BlockTitle>
                <AmountTitle>Summary</AmountTitle>
              </BlockTitle>
              <AmountList>
                {DataDurationList.map((item: any, index: number) => {
                  return (
                    (
                      <>
                        <AmountItem key={index}>
                          <span>{item.stakeDay.title}</span>
                          <span>{item.stakeDay.value}</span>
                        </AmountItem>
                        <AmountItem key={index}>
                          <span>{item.interestEndDay.title}</span>
                          <span>{item.interestEndDay.value}</span>
                        </AmountItem>
                        <AmountItem key={index}>
                          <span>{item.redemptionPeriod.title}</span>
                          <span>{item.redemptionPeriod.value}</span>
                        </AmountItem>
                      </>
                    )
                  );
                })}
              </AmountList>
            </BlockSummary>
          </ContentInnerRight>
        </ContentDuration>
      </ContentRightInner>
    </>
  );
};

const duration = [
  {
    title: "30 D",
    value: 1,
    text: "5.0% APY",
  },
  {
    title: "60 D",
    value: 2,
    text: "10.0% APY",
  },
  {
    title: "90 D",
    value: 3,
    text: "16.0% APY",
  },
  {
    title: "180 D",
    value: 4,
    text: "35.0% APY",
  },
];

const DataDurationList = [
  {
    id: 1,
    pendingReward: {
      title: "Pending Reward",
      value: ""
    },
    depositFee: {
      title: "Deposit Fee",
      value: ""
    },
    claimFee: {
      title: "Claim Fee",
      value: ""
    },
    yourStakedAmount: {
      title: "Your Staked Amount",
      value: ""
    },
    yourClaimableAmount: {
      title: "Your Claimable Amount",
      value: ""
    },
    duration: {
      title: "Duration",
      value: "30 days",
    },
    apy: {
      title: "APY",
      value: "5.0%",
    },
    staked: {
      title: "Total staked",
      value: "--- TON",
    },
    stakers: {
      title: "Stakers",
      value: "--- TON",
    },
    exchange: {
      title: "Exchange rate",
      value: "TBA",
    },
    poolAddress: {
      title: "Pool address",
      value: "TBA",
    },
    stakeDay: {
      title: "Stake day",
      value: "---",
    },
    interestEndDay: {
      title: "Interest end day",
      value: "---",
    },
    redemptionPeriod: {
      title: "Redemption period",
      value: "30 days",
    },
  },
];

export default Stake;
